import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Dropdown as t } from "../shared/dropdown/Dropdown.component.js";
import { useMergeThemeVariables as u } from "../shared/utils.js";
import { useHandleOpen as x } from "./hooks/hooks.js";
import { useFileAction as f } from "./hooks/use-file-actions.hook.js";
import { renderIcon as h } from "./icons/file-icon.utils.js";
import { formatMessageTimestamp as w } from "./utils.js";
const O = ({
  file: p,
  copies: n,
  onDeleteEntry: o,
  onCopy: r,
  onDownload: s,
  onView: m
}) => {
  const d = u(
    "dropdown",
    t.themeKeys,
    {}
  ), l = x(p.url), { renderMenuContent: i, renderbutton: c } = f({
    copies: n,
    file: p,
    onDeleteEntry: o,
    onCopy: r,
    onDownload: s,
    onView: m
  });
  return /* @__PURE__ */ a(
    "div",
    {
      className: "app:flex app:items-center app:bg-stone-50 app:hover:bg-stone-100 app:rounded-xl app:p-2 app:gap-4 app:h-20 app:cursor-pointer app:justify-between",
      onDoubleClick: l,
      children: [
        /* @__PURE__ */ a("div", { className: "app:flex app:gap-5 app:h-full app:items-center", children: [
          p.type === "img" ? /* @__PURE__ */ e(
            "img",
            {
              src: p.url,
              alt: p.name,
              className: "app:w-[80px] app:md:w-[120px] app:min-w-[80px] app:md:min-w-[120px] app:h-full app:object-scale-down app:rounded-md app:bg-white"
            }
          ) : /* @__PURE__ */ e("div", { className: "app:w-[80px] app:md:w-[120px] app:min-w-[80px] app:md:min-w-[120px] app:flex app:items-center app:bg-white app:h-full app:rounded-md app:object-contain app:aspect-auto app:justify-center", children: h(p.type) }),
          /* @__PURE__ */ a("div", { className: "app:flex app:flex-col app:text-left app:gap-0 app:h-full app:justify-center app:overflow-hidden app:text-ellipsis app:break-words app:break-all", children: [
            /* @__PURE__ */ e("div", { className: "app:font-semibold app:text-md", children: p.name }),
            /* @__PURE__ */ e("div", { className: "app:text-sm app:text-stone-400", children: w(p.updatedAt) })
          ] })
        ] }),
        /* @__PURE__ */ e(
          t,
          {
            theme: d,
            plateMinWidth: 100,
            renderButton: c,
            leftPlateOffset: -90,
            topPlateOffset: 8,
            renderMenuContent: i,
            dropdownMenuClass: "app:min-w-1"
          }
        )
      ]
    }
  );
};
export {
  O as FileListItem
};
